// export const uuidv4 = () => {
//     return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
//         (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
//     );
// }

export const uniqueId = () => Date.now().toString(36) + Math.random().toString(36).substring(2);